<page-grid [gridConfig]="gridConfig()"/>
